"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markdownTrilogy = void 0;
const markdown_it_1 = __importDefault(require("markdown-it"));
const youtube_embedder_1 = __importDefault(require("./youtube-embedder"));
const trilogy_renderer_1 = __importDefault(require("./trilogy-renderer"));
const CTA_renderer_1 = __importDefault(require("./CTA-renderer"));
const markdownTrilogy = markdownText => {
  const md = new markdown_it_1.default().use(trilogy_renderer_1.default).use(youtube_embedder_1.default).use(CTA_renderer_1.default).use(require('markdown-it-sup'));
  return md.render(markdownText);
};
exports.markdownTrilogy = markdownTrilogy;
